module.exports = __webpack_public_path__ + "img/AvatarSleep@2x.1206b162.png";